import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import type { InternalLabelMasterListItem } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { Row } from './Row'

type Props = {
  labelMasters: InternalLabelMasterListItem[]
}

const headers = [
  'ラベルマスタ名',
  'ラベルマスタ管理番号',
  '呼び出しバーコード番号',
  'ステータス',
  '作成日時',
  'QRコード',
  '',
]

export const LabelMasterTable: FC<Props> = ({ labelMasters }) => {
  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table sx={{ bgcolor: 'white', width: '100%' }}>
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                px: 2,
                py: 1,
                whiteSpace: 'nowrap',
              },
            }}
          >
            {headers.map(header => (
              <TableCell key={header || 'action'}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {labelMasters.map(master => (
            <Row key={master.id} labelMaster={master} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
